"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SubMenu = require("../SubMenu/SubMenu");

var _SubMenu2 = _interopRequireDefault(_SubMenu);

var _HeaderContext = require("../HeaderContext");

var _HeaderContext2 = _interopRequireDefault(_HeaderContext);

require("./MenuItem.css");

var _fs = require("fs");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MenuItem = function MenuItem(props) {
  var authenticated = props.authenticated,
      label = props.label,
      route = props.route,
      subdomain = props.subdomain,
      hideByPlans = props.hideByPlans,
      subRoutes = props.subRoutes,
      id = props.id,
      inApp = props.inApp,
      live = props.live,
      _onClick = props.onClick,
      userInfo = props.userInfo;

  var showByAuthentication = function showByAuthentication(route) {
    if (route && route.authReq) {
      if (authenticated) {
        return true;
      }

      return false;
    }

    return true;
  };

  var showByUserPlan = function showByUserPlan(hideByPlans, userInfo) {
    if (!hideByPlans) {
      return true;
    }

    if (!userInfo || !userInfo.planCode) {
      return false;
    }

    var isBlacklisted = hideByPlans.includes(userInfo.planCode);
    return !isBlacklisted;
  };

  return _react2.default.createElement(_HeaderContext2.default.Consumer, null, function (context) {
    var expandedMenu = context.expandedMenu,
        setExpandedMenu = context.setExpandedMenu;
    return _react2.default.createElement("div", null, showByAuthentication(route) && showByUserPlan(hideByPlans, userInfo) && _react2.default.createElement("div", {
      className: "route-button"
    }, _react2.default.createElement("button", {
      className: "naked-button cur-pointer flex-aic fs-14 d-flex c-black",
      onClick: function onClick() {
        _onClick({
          route: route,
          subdomain: subdomain,
          inApp: inApp
        });
      },
      onMouseOver: function onMouseOver() {
        if (subRoutes && !!subRoutes.length) {
          setExpandedMenu(props);
        }
      }
    }, label, " ", live && _react2.default.createElement("span", {
      className: "live-badge mar-4"
    }, "LIVE"), subRoutes && !!subRoutes.length && _react2.default.createElement("i", {
      className: "material-icons"
    }, "arrow_drop_down")), expandedMenu && expandedMenu.id == id && subRoutes && _react2.default.createElement(_SubMenu2.default, {
      subRoutes: subRoutes,
      onMouseLeave: function onMouseLeave() {
        setExpandedMenu();
      },
      onRouteClick: _onClick
    })));
  });
};

exports.default = MenuItem;